/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_HintInputs */

const cs_properties_bulk_transfer_hint = /** @type {(inputs: Properties_Bulk_Transfer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeřadí vybrané nemovitosti jinému makléři v této kanceláři.`)
};

const en_properties_bulk_transfer_hint = /** @type {(inputs: Properties_Bulk_Transfer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reassign the selected listings to another agent in this office.`)
};

/**
* | output |
* | --- |
* | "Reassign the selected listings to another agent in this office." |
*
* @param {Properties_Bulk_Transfer_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_hint = /** @type {((inputs?: Properties_Bulk_Transfer_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_hint(inputs)
	return cs_properties_bulk_transfer_hint(inputs)
});